import { render, staticRenderFns } from "./moveImg.vue?vue&type=template&id=5a48ec10&scoped=true&"
import script from "./moveImg.vue?vue&type=script&lang=js&"
export * from "./moveImg.vue?vue&type=script&lang=js&"
import style0 from "./moveImg.vue?vue&type=style&index=0&id=5a48ec10&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48ec10",
  null
  
)

export default component.exports